import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-shield-star-line text-2xl text-primary-500"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              为什么选择<strong>久久影视</strong>？
            </h2>
            <p className="text-sm text-foreground-500 max-w-2xl mx-auto mb-10">
              高清不卡顿，全集免费看，无需等待更新，一次性看完整部剧
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { icon: 'ri-shield-check-line', title: '高清画质', desc: '1080P超清体验' },
                { icon: 'ri-flashlight-line', title: '秒播不卡', desc: '极速加载流畅' },
                { icon: 'ri-timer-flash-line', title: '全集一次看', desc: '无需等更新' },
                { icon: 'ri-global-line', title: '海量剧库', desc: '国产韩剧全覆盖' },
              ].map((item) => (
                <div key={item.title} className="p-5 rounded-xl bg-background-100">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                    <i className={`${item.icon} text-lg text-primary-500`}></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h4>
                  <p className="text-xs text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}